import { getVideoContents } from "../../services/index";
import { useQuery } from "react-query";

export const useGetVideoContentsData = () => {
  const { data: videoContents, isLoading: getVideoContentsIsLoading } =
    useQuery("videoContents", getVideoContents);
  return { videoContents, getVideoContentsIsLoading };
};
